import React from 'react'
import { Grid, IconButton, Typography, makeStyles } from '@material-ui/core'
import { useHomeStore } from 'context/HomeStore'
import { NoAssign } from './components/NoAssign/NoAssign'
import { ChatMessage } from './components/ChatMessage/ChatMessage'
import { ChatInput } from './components/ChatInput/ChatInput'
import { LoaderBackdrop } from 'asterX-UIkit/Loaders'
import ChevronLeftIcon from 'asterX-UIkit/Icons/ChevronLeftIcon'
import { REQUEST_PATH } from 'routes/constants.routes'
import { useRoutes } from 'hooks'
import { GRAY_COLORS } from 'asterX-UIkit'
import RenewModal from '../Modals/RenewModal/RenewModal'
import ReviewModal from '../Modals/ReviewModal/ReviewModal'

const useStyles = makeStyles(theme => ({
  headContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: 12,
    position: 'fixed',
    top: 0,
    zIndex: 10,
    backgroundColor: GRAY_COLORS[25],
    borderBottom: `1px solid ${GRAY_COLORS[300]}`
  },
  inputContainer: {
    position: 'fixed',
    bottom: 15,
    zIndex: 10,
    paddingLeft: 10,
    paddingRight: 10
  },
  chatContainer: {
    overflowY: 'auto',
    paddingTop: 60,
    height: '91vh',
    flexWrap: 'nowrap',
    borderBottom: `1px solid ${GRAY_COLORS[300]}`
  }
}))

const ChatPage = () => {
  const classes = useStyles()
  const router = useRoutes()

  const handleGoBack = id => {
    router.goTo(`${REQUEST_PATH}/${id}`)
  }

  const {
    homeStore: { requestList, loading, openReviewModal, openRenewModal },
    homeStoreFunc: { setOpenReviewModal, setOpenRenewModal }
  } = useHomeStore()

  return (
    <Grid item container>
      <LoaderBackdrop loading={loading} />
      <Grid item container xs={12} md={12} className={classes.headContainer}>
        <IconButton
          style={{ padding: 0, marginRight: 8 }}
          onClick={() => handleGoBack(requestList?.id)}
        >
          <ChevronLeftIcon />
        </IconButton>
        <Typography variant="subtitle1">Чат с поддержкой</Typography>
      </Grid>
      <Grid
        item
        container
        direction={'column'}
        className={classes.chatContainer}
      >
        {!requestList.adminFullname && (
          <Grid item container style={{ height: '100%' }}>
            <NoAssign />
          </Grid>
        )}
        {!!requestList.adminFullname && (
          <Grid item>
            <ChatMessage />
          </Grid>
        )}
      </Grid>
      <Grid item container xs={12} md={12} className={classes.inputContainer}>
        <ChatInput />
      </Grid>
      <RenewModal
        requestList={requestList}
        open={openRenewModal}
        fullWidth
        onClose={() => setOpenRenewModal(false)}
      />
      <ReviewModal
        requestList={requestList}
        open={openReviewModal}
        fullWidth
        onClose={() => setOpenReviewModal(false)}
      />
    </Grid>
  )
}

export default ChatPage
